import { Tooltip } from "antd";
import React from "react";
import { appHelper } from "../common/helper";

const TeamBadge = ({ color, text, className = '', Truncate = true , tooltipText=""}) => {
  debugger
  const { truncateByLength } = appHelper();


  return (
    <div className={`${className}  badge-wrapper`}>
      {color && (
        <div style={{ backgroundColor: color }} className="badge-color"></div>
      )}
      <Tooltip title={tooltipText ? tooltipText : ""}>
        <p> {Truncate === true ? truncateByLength(text, 12) : text} </p>
      </Tooltip>
    </div>
  );
};

export default TeamBadge;
